import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SettingsAccessPopupPage } from './settings-access-popup.page';

const routes: Routes = [
  {
    path: '',
    component: SettingsAccessPopupPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsAccessPopupPageRoutingModule {}
